import { useController, useFormContext } from 'react-hook-form'

import styles from '../OfficialReportModal.module.scss'
import { Input, TextArea } from '@/components/Forms'
import { OFFICIAL_REPORT_FORM_FIELDS } from '../../constant'
import { DetailsEditor } from './DetailsEditor'
import { OfficialReportType } from '@/types/officialReport'
import { isLateOfficialReportType, isHeadwayOfficialReportType } from '../../helpers/checkReportType'

const LOCATION_MAX_LENGTH = 200

export const IncidentDetails = ({ type }: { type: OfficialReportType }) => {
    const { register, control, setValue } = useFormContext()
    const { field } = useController({ control, name: OFFICIAL_REPORT_FORM_FIELDS.details })
    const isStructured = isLateOfficialReportType(type) || isHeadwayOfficialReportType(type)

    return (
        <div className={styles.wrapper}>
            <p className={styles.subtitle}>Incident details</p>
            <Input
                className={styles.inputField}
                fullWidth
                label="Location of issue"
                placeholder="Location of issue"
                {...register(OFFICIAL_REPORT_FORM_FIELDS.locationOfIssue)}
                maxLength={LOCATION_MAX_LENGTH}
            />
            {isStructured ? (
                <TextArea
                    label="Driver's statement"
                    className={styles.textareaField}
                    placeholder="What did the driver say?"
                    {...register(OFFICIAL_REPORT_FORM_FIELDS.driverStatement)}
                />
            ) : (
                <DetailsEditor
                    value={field.value}
                    className={styles.textareaField}
                    onChange={(value) => setValue(field.name, value, { shouldDirty: true })}
                />
            )}
        </div>
    )
}
